import PropTypes from "prop-types"

import { Button, CloseButton } from "@/components/Button"
import { Paragraph } from "@/components/Paragraph"
import { theme } from "@/theme"

import { ButtonContainer, ButtonWrapper } from "./styled"

/**
 * Displays the close and submit buttons in the bottom of a modal
 *
 * @param {Object} props
 * @param {function} props.handleClose - The function to handle closing the modal
 * @param {function} props.handleUpdate - The function to handle updating the data
 * @param {string} props.closeText - The text of the close button
 * @param {string} props.text - The text of the paragraph above the buttons
 * @param {boolean} props.disabled - If true, the submit button is disabled
 * @param {boolean} props.submit - If true, the second button is a submit button
 * @param {ReactNode} props.children - The icon and text of the submit button
 * @param {string} props.confirmTestId - The test ID for the confirm button
 * @param {string} props.cancelTestId - The test ID for the cancel button
 * @returns {JSX.Element}
 */
export const ModalButtons = ({
  handleClose,
  handleUpdate,
  closeText,
  text,
  disabled,
  submit,
  children,
  confirmTestId,
  cancelTestId,
}) => {
  return (
    <ButtonContainer $secondary={text}>
      {text && <Paragraph text={text} />}
      <ButtonWrapper $flex={text}>
        <CloseButton text={closeText} handleClick={handleClose} data-testid={cancelTestId} />
        <Button
          handleClick={handleUpdate}
          size={theme.iconSizes.normal}
          disabled={disabled}
          secondary={!text}
          rounded
          submit={submit}
          data-testid={confirmTestId}
        >
          {children}
        </Button>
      </ButtonWrapper>
    </ButtonContainer>
  )
}

ModalButtons.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  closeText: PropTypes.string.isRequired,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  submit: PropTypes.bool,
  children: PropTypes.node,
  confirmTestId: PropTypes.string,
  cancelTestId: PropTypes.string,
}
